import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100">
          <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
        </div>
        <h1 className="text-6xl md:text-8xl font-bold text-foreground-900 mb-4 font-heading">
          404
        </h1>
        <p className="text-lg text-foreground-600 mb-2">页面未找到</p>
        <p className="text-sm text-foreground-400 font-mono mb-8">{location.pathname}</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}